import * as React from "react";
const SvgFiRrSelection = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-selection_svg__a)">
      <path
        fill="#062147"
        d="M19 2a2 2 0 1 1 3.999-.001 2 2 0 0 1-4 .001M3 4A2 2 0 1 0 3.001.001 2 2 0 0 0 3 4m20.969 3.121A3 3 0 0 0 21.099 5h-1.168c.04.328.069.661.069 1 0 .692-.097 1.36-.262 2h3.603c.454 0 .76-.444.628-.879M3.999 6c.001-.339.029-.672.07-1H2.915A3 3 0 0 0 .021 7.208C-.09 7.611.25 8 .668 8h3.594A8 8 0 0 1 4 6m8 0a1.5 1.5 0 1 0 0-3.001 1.5 1.5 0 0 0 0 3.001m10 16.942a1 1 0 0 1-.94 1.057l-.06.001a1 1 0 0 1-.997-.942 3 3 0 0 0-1.941-2.633l-4.38-1.477A1 1 0 0 1 13 18v-4.893c0-.537-.362-1.017-.825-1.093A1 1 0 0 0 11 13v7.455c0 .608-.34 1.15-.89 1.415a1.56 1.56 0 0 1-1.659-.186S6.69 20.279 6.68 20.269a1.001 1.001 0 0 0-1.364 1.464l.568.548c.648.624.206 1.72-.694 1.72a1 1 0 0 1-.694-.28l-.558-.538a2.995 2.995 0 0 1 4.021-4.438l1.04.821v-6.563c0-.567.174-1.106.467-1.576a5.99 5.99 0 0 1-3.467-5.424c0-3.309 2.691-6 6-6s6 2.691 6 6a5.96 5.96 0 0 1-3.482 5.435c.302.488.482 1.062.482 1.672v4.175l3.73 1.258a5.02 5.02 0 0 1 3.269 4.401zM8 6c0 1.11.46 2.135 1.221 2.872A2.99 2.99 0 0 1 11.99 7h.017a2.99 2.99 0 0 1 2.769 1.875A3.98 3.98 0 0 0 16 6c0-2.206-1.794-4-4-4S8 3.794 8 6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-selection_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSelection;
